<template>
  <div>
    <validation-observer ref="fttbForm">
      <b-card title="FTTH-Versorgung" v-if="SERVICE && SERVICE.connectionType === 'FTTH' && SERVICE.hasInternet">
        <p>Zur Aktivierung der von Ihnen gebuchten Leistungen benötigen wir die Seriennummer Ihres ONT. Was das ist und
          wo Sie diese finden, können Sie <a title=""
                                             href="https://cable4.de/downloads/service/Cable4_InfoONT_2412.pdf"
                                             target="_blank" rel="nofollow noopener"><strong>diesem PDF</strong></a>
          entnehmen. Sollte der ONT bei Ihnen noch nicht installiert sein, können Sie dieses Feld ignorieren. Vielen Dank!</p>

        <b-form-group label="ONT-Seriennummer" label-for="fttb-ont-serial-number" class="required">
          <validation-provider
              #default="{ errors }"
              name="ONT-Seriennummer"
              rules="required"
          >
            <b-form-input
                id="fttb-ont-serial-number"
                v-model="CHECKOUT_DATA.ont_serial_number"
                placeholder="Bitte geben Sie die ONT-Seriennummer an."
            />
            <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BCol,
  BFormCheckbox, BFormGroup, BFormInput, BRow,
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'
import {required_if} from 'vee-validate/dist/rules';

export default {
  name: "FTTHSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      separateAccountOwner: false,
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.fttbForm.validate()
    }
  }
}
</script>

<style scoped>

</style>
